import SqFetch from 'application/fetch';

export default class AddressValidationClient {
  _handleResponse(response) {
    if (!response.ok) {
      throw new Error(response);
    }
    return response.json();
  }

  validateAddress(address) {
    return SqFetch.post('/shop/hardware/api/v1/addresses/validate', {
      address_validation_request: {
        save: false,
        address,
      },
    }).then(this._handleResponse);
  }
}
